import axios from 'axios';

import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  auth: {
    me: '/api/v1/session/recoverySession',
    login: '/api/v1/session/login',
    forgotPassword: '/api/v1/session/resetPassword',
    verificarToken: (token) => `/api/v1/session/check-token-reset/${token}`,
    changePassword: '/api/v1/session/change-password',
    catalogs: '/api/v1/administration/users/public/catalogs',
    logout: '/api/v1/session/logout',
  },
  user: {
    list: '/api/v1/administration/users',
    create: '/api/v1/administration/users',
    update: '/api/v1/administration/users',
    delete: '/api/v1/administration/users',
    changePassword: '/api/v1/administration/users/change-password',
    affiliatedBranches: '/api/v1/administration/users/affiliatedBranches',
  },
  branches: {
    list: '/api/v1/maintenance/branches/',
    listByCompany: '/api/v1/maintenance/branches/companie',
    update: '/api/v1/maintenance/branches/',
    create: '/api/v1/maintenance/branches/',
    delete: '/api/v1/maintenance/branches/',
  },
  companies: {
    list: '/api/v1/maintenance/companies/',
    update: '/api/v1/maintenance/companies/',
    create: '/api/v1/maintenance/companies/',
    listSelects: '/api/v1/maintenance/companies/selects',
    delete: '/api/v1/maintenance/companies/',
  },
  products: {
    list: '/api/v1/maintenance/products/',
    update: '/api/v1/maintenance/products/',
    create: '/api/v1/maintenance/products/',
    listSelects: '/api/v1/maintenance/products/selects',
    delete: '/api/v1/maintenance/products/',
    updateStock: '/api/v1/maintenance/products/stockAdjust',
  },
  rol: {
    list: '/api/v1/administration/roles',
    create: '/api/v1/administration/roles',
    update: '/api/v1/administration/roles',
    delete: '/api/v1/administration/roles',
  },
  relationRolService: {
    list: '/api/v1/administration/rolServices',
    create: '/api/v1/administration/rolServices/dinamicAccordion',
  },
  orders: {
    list: '/api/v1/maintenance/orders',
    markAsCollected: '/api/v1/maintenance/orders/markAsCollected',
    cancel: '/api/v1/maintenance/orders/cancel',
    refund: '/api/v1/maintenance/orders/refund',
    returnToInventory: '/api/v1/maintenance/orders/returnToInventory',
    discard: '/api/v1/maintenance/orders/discard',
  },
  orderHistory: {
    list: '/api/v1/maintenance/ordersHistory',
  },
  finance: {
    list: '/api/v1/maintenance/finance',
  },
  generalData: {
    getGeneralData: '/api/v1/generalData',
  }
};
